import * as React from 'react';
import Button from '@mui/material/Button';
import NextButton from '@mui/material-next/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useMediaQuery, useTheme } from '@mui/material';
import parse, { domToReact } from 'html-react-parser'
import { Divider } from '@mui/material';
import { Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import LoadingButton from '@mui/lab/LoadingButton';
import { useNavigate } from 'react-router';

export default function CommonDialog(props) {
  const [proccessStart, setProccessStart] = React.useState(false)
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  
  // モバイルでは強制的に全画面表示にする（propsで無効化可能）
  const shouldFullScreen = props.fullScreen || (isMobile && props.mobileFullScreen !== false)

  React.useEffect(() => {

  },[proccessStart])

  return (
    <React.Fragment>
      <Dialog
        style={{
          maxWidth: !shouldFullScreen ? (props.maxWidth !== undefined ? props.maxWidth : "600px") : "100%",
          margin: "0 auto"
        }}
        maxWidth={false}
        fullScreen={shouldFullScreen}
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: shouldFullScreen ? {
            width: "100%",
            height: "100%",
            maxWidth: "100%",
            maxHeight: "100%",
            margin: 0,
            borderRadius: 0
          } : {
            width: props.maxWidth !== undefined ? props.maxWidth : "600px",
            maxWidth: props.maxWidth !== undefined ? props.maxWidth : "600px",
            minWidth: props.minWidth !== undefined ? props.minWidth : "400px"
          }
        }}
      >
        {props.title !== undefined && props.title !== "" ?
        (<DialogTitle id="alert-dialog-title" sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          pr: shouldFullScreen ? 1 : 3
        }}>
          <span>{props.title}</span>
          {shouldFullScreen && (
            <IconButton
              aria-label="close"
              onClick={props.onClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>) : shouldFullScreen ? (
          <DialogTitle sx={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            alignItems: 'center',
            py: 1,
            pr: 1
          }}>
            <IconButton
              aria-label="close"
              onClick={props.onClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        ) : ""}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div>
              {props.content}
            </div>
            {props.buttonLabel !== undefined ? <div className='text-center mt-1'>
              {!proccessStart ? <Button className='m-2' variant='contained' color={props.buttonColor || "primary"} onClick={() => {
                props.onClick()
              }}>{props.buttonLabel}</Button> :
              <LoadingButton className='m-2' loading variant="outlined" color={props.buttonColor || "primary"}>{buttonLabel}</LoadingButton>}
              {props.showCancelbutton !== undefined ? <Button className='m-2' variant='outlined' onClick={() => props.onClose()}>キャンセル</Button> : ""}
            </div> : ""}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}